import { render, staticRenderFns } from "./BtnResetar.vue?vue&type=template&id=2da573b4&"
import script from "./BtnResetar.vue?vue&type=script&lang=js&"
export * from "./BtnResetar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports